import type { CandidateVacancy } from '../types';
import { mockCandidateActivitySphere } from './mockCandidateActivitySphere';
import { mockCandidateCity } from './mockCandidateCity';
import { mockCandidateEconomicActivity } from './mockCandidateEconomicActivity';
import { mockCandidateUser } from './mockCandidateUser';

type CandidateCompany = NonNullable<CandidateVacancy['company']>;

export function mockCandidateCompany(
  overrides: Partial<CandidateCompany> = {}
): CandidateCompany {
  return {
    id: 1,
    name: 'Example Company',
    type: 'limited_liability_company',
    nif: 'FR123456789',
    regionId: 1,
    description: 'A software development company',
    isActive: true,
    isSurfer: false,
    nccVerified: true,
    rating: 4.5,
    level: 'gold',
    createdAt: '2025-12-01T08:00:00.000Z',
    updatedAt: '2026-06-15T08:00:00.000Z',
    manager: mockCandidateUser(),
    city: mockCandidateCity(),
    activitySpheres: [mockCandidateActivitySphere()],
    economicActivities: [mockCandidateEconomicActivity()],
    ...overrides,
  };
}
